// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"cb6d1a42","126":"da4d9b9e","193":"90226f53","431":"d1eba662","489":"a6ce8ccf","608":"786006d9","787":"0e3d155a"}[chunkId] + ".chunk.js";
};